// extracted by mini-css-extract-plugin
export default {"googleButton":"cus5dj849"};